const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "trade":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "trade",
    reducer: reducer,
};

export default data;